import React from 'react';
import PropTypes from 'prop-types';

import Tag from '@decisiv/ui-components/lib/components/Tag';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import OverflowPopover from '../../shared/OverflowPopover';
import roleTag, { PERMISSION_ASSIGNMENT } from '../../shared/roleTag';
import { PanelRow, TagRow } from '../../shared/styles';
import EMPTY_VALUE from '../../shared/emptyValue';

export const MIXED_PERMISSIONS = 'Mixed Permissions';

/**
 * The PERMISSIONS column.
 *
 * Roles are assigned per account, so someone working across accounts holds
 * several. One role shows as itself; more than one collapses to a single
 * "Mixed Permissions" tag whose chevron expands to an account-by-account
 * breakdown — there is no count badge on this cell, unlike ACCOUNTS.
 */
function PermissionsCell({ permissionAssignments, permissions }) {
  if (!permissions.length) {
    return <P shade={1}>{EMPTY_VALUE}</P>;
  }

  if (permissions.length === 1) {
    return <TagRow>{roleTag(permissions[0])}</TagRow>;
  }

  return (
    <TagRow>
      <OverflowPopover
        ariaLabel="Show permissions by account"
        label={MIXED_PERMISSIONS}
      >
        {/* Index keys are safe here and elsewhere would not be: the list is
            derived, never reordered or spliced, and a composed
            `account-permission` key can collide when either value contains a
            hyphen. */}
        {permissionAssignments.map(({ account, permission }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <PanelRow key={index}>
            <Tag text={account} variant="outline" />
            {roleTag(permission)}
          </PanelRow>
        ))}
      </OverflowPopover>
    </TagRow>
  );
}

PermissionsCell.propTypes = {
  /** Drives the expanded panel. */
  permissionAssignments: PropTypes.arrayOf(PERMISSION_ASSIGNMENT),
  /** Distinct role names; drives the inline tag. */
  permissions: PropTypes.arrayOf(PropTypes.string),
};

PermissionsCell.defaultProps = {
  permissionAssignments: [],
  permissions: [],
};

export default PermissionsCell;
